import React, { useEffect, useRef } from "react";
import "./timeflow.css";

const TimeFlow = () => {
  const itemsRef = useRef([]);

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        } else {
          // Remove the class when out of view so it can animate again
          entry.target.classList.remove("show");
        }
      });
    },
    { threshold: 0.3 }
  );

  itemsRef.current.forEach((item) => {
    if (item) observer.observe(item);
  });

  return () => observer.disconnect();
}, []);


  const data = [
    { year: "2007", title: "Birth of a Vision: VCNR Warehousing", content: "Laying the foundation for excellence with state-of-the-art warehouse construction services." },
    { year: "2015", title: "VCNR Builders & Developers: The Corporate Leap", content: "Transforming skylines with innovative, high-quality, and sustainable real estate projects." },
    { year: "2015", title: "VCNR Technologies: Innovating Tomorrow", content: "Driving digital transformation through cutting-edge technology solutions and services." },
    { year: "2018", title: "VCNR Healthcare: Caring for Communities", content: "Delivering quality healthcare solutions with compassion, innovation, and commitment." },
    { year: "2019", title: "Hithachinthana Charitable Trust: Giving Back", content: "Empowering lives through impactful social initiatives and charitable programs." },
    { year: "2021", title: "VCNR Agrotech: Cultivating the Future", content: "Revolutionizing agriculture with modern technology for sustainable food production." },
    { year: "2022", title: "VCNR Education: Inspiring Young Minds", content: "Shaping future leaders through innovative, accessible, and quality education." },
    { year: "2023", title: "VCNR Hospitality: Redefining Comfort", content: "Crafting unforgettable guest experiences with luxury, warmth, and impeccable service." },
    { year: "2025", title: "VCNR Gold & Diamonds: Timeless Elegance", content: "Creating exquisite jewellery that blends tradition, craftsmanship, and modern style." },
  ];

  return (
    <div className="time-line">
      <ul>
        {data.map((item, index) => (
          <li
            key={index}
            ref={(el) => (itemsRef.current[index] = el)}
            className={index % 2 === 0 ? "left" : "right"}
          >
            <div className="year">
              <span>{item.year}</span>
            </div>
            <div className="content">
              <h5>{item.title}</h5>
              <p>{item.content}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TimeFlow;
